import * as messageService from "../../services/message.service";
import * as visaTypeService from '../../services/visaType.service';


const state = {
    visaTypeAll:[],
    visaTypeAllActive:[],
};

const getters = {
    gettVisaTypeAll:state => (state.visaTypeAll),
    gettVisaTypeAllActive:state => (state.visaTypeAllActive),
};

const actions = {
    async fetchVisaTypeAll({ commit } ){
        try {
            const response = await visaTypeService.all();
            commit('setVisaTypeAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchVisaTypeAllActive({ commit } ){
        try {
            const response = await visaTypeService.allActive();
            commit('setVisaTypeAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setVisaTypeAll:(state, res) => (
        state.visaTypeAll =  res
    ),
    setVisaTypeAllActive:(state, res) => (
        state.visaTypeAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}